import type { SubscriptionCancelStore } from '@stores/subscription-cancel/interfaces'

import { CancelReason } from '@brighterly/lib-core-types/subscription/enums'

const isReason = (state: SubscriptionCancelStore, reasons: CancelReason[]): boolean => {
  return !state.cancelReason
    ? false
    : reasons.includes(state.cancelReason)
}

export const isTimeShortage = (state: SubscriptionCancelStore): boolean => isReason(state, [CancelReason.NoTimeForLessons])

export const isTooExpensive = (state: SubscriptionCancelStore): boolean => isReason(state, [CancelReason.TooExpensive])

export const isDiscountOffer = (state: SubscriptionCancelStore): boolean => isReason(state, [
  CancelReason.TooExpensive,
  CancelReason.PreferInPersonTutor,
  CancelReason.NoReason,
])

export const isPremiumTutorOffer = (state: SubscriptionCancelStore): boolean => isReason(state, [
  CancelReason.HaventNoticedImprovement,
  CancelReason.TryDifferentTutor,
])

export const isSecondDiscipline = (state: SubscriptionCancelStore): boolean => isReason(state, [CancelReason.HasAchievedGoals])

export const isPauseOffer = (state: SubscriptionCancelStore): boolean => isReason(state, [CancelReason.Other])

export const cancelScenarios = {
  isTimeShortage: (state: SubscriptionCancelStore): boolean => isTimeShortage(state),
  isTooExpensive: (state: SubscriptionCancelStore): boolean => isTooExpensive(state),
  isDiscountOffer: (state: SubscriptionCancelStore): boolean => isDiscountOffer(state),
  isPremiumTutorOffer: (state: SubscriptionCancelStore): boolean => isPremiumTutorOffer(state),
  isSecondDiscipline: (state: SubscriptionCancelStore): boolean => isSecondDiscipline(state),
  isPauseOffer: (state: SubscriptionCancelStore): boolean => isPauseOffer(state),
}
